import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.other.spacing._24,
    boxShadow: 'none',
    borderRadius: theme.radius.sm,
    background: 'transparent',
  },
}));

export default useStyles;
